import React from "react";
import { Box } from "@chakra-ui/react";

interface Props {
  value?: number;
}
export const NotificationBadge: React.FC<Props> = ({ value }) => {
  if (!value) return null;
  return (
    <Box
      fontSize="2xs"
      position="absolute"
      top="-4px"
      right="-8px"
      py="2px"
      px="6px"
      borderRadius="lg"
      color="white"
      bgColor="primary.600"
    >
      {value < 100 ? value : "+99"}
    </Box>
  );
};
